// TODO: Remove. Kept for compatibility with older color generation output
import type { ColorLabel as ColorLabelOld } from "common/constants/colorsOld";
import type { ReactNode } from "react";
import cx from "ui/cx";
import type { ColorLabel } from "ui/styles/colors";
import styles from "./Capsule.module.scss";

export type CapsuleSize = "mini" | "small" | "smallX1" | "large";

export interface CapsuleProps extends React.HTMLAttributes<HTMLDivElement> {
  label: ReactNode;
  color?: ColorLabel | ColorLabelOld;
  backgroundColor?: ColorLabel | ColorLabelOld;
  icon?: ReactNode;
  size?: CapsuleSize;
  /** Optional content to render on the right side of the label (e.g., a button) */
  action?: ReactNode;
}

/**
 * Relies on output from tools/genColors to provide color and background color classes.
 */
export default function Capsule({
  label,
  icon,
  color,
  backgroundColor,
  size = "large",
  className,
  action,
  ...props
}: CapsuleProps) {
  return (
    <div
      className={cx(
        styles.wrapper,
        styles[size],
        color,
        backgroundColor && `${backgroundColor}Bg`,
        !color && styles.color,
        !backgroundColor && styles.backgroundColor,
        { [styles.hasAction]: Boolean(action) },
        className,
      )}
      {...props}
    >
      {icon && <div className={styles.icon}>{icon}</div>}
      <span>{label}</span>
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}

export type StudioCapsuleProps = Omit<CapsuleProps, "size">;

export function StudioCapsule(props: StudioCapsuleProps) {
  return <Capsule size="mini" {...props} />;
}
